import { useGameReportSearchParams } from '@/hooks/gameReport/useGameReportSearchParams';
import { GameReportType } from '@/hooks/gameReport/useGameReportSearchParams/gameReportType.enum';
import GameDetailsContentBoardBet from './Bet';
import GameDetailsContentBoardRound from './Round';

export default function GameDetailsContentBoard() {
  const { type } = useGameReportSearchParams();

  switch (type) {
    case GameReportType.BetGame:
      return <GameDetailsContentBoardBet />;
    case GameReportType.RoundGame:
      return <GameDetailsContentBoardRound />;
  }
}
